export default "__VITE_ASSET__JDAkx$Ct__"